module.exports = __webpack_public_path__ + "static/media/01-wagner-barreira.d078655a.webp";